import KrushiVishwaUpdates from "../Components/Updates/KrushiVishwaUpdates"
import "bootstrap/dist/css/bootstrap.min.css"
import "./LatestUpdates.css"

function App() {
  return (
    <div className="App">
      <KrushiVishwaUpdates />
    </div>
  )
}

export default App
